import {NgModule} from '@angular/core';
import {CrudOverviewDataModule, EditorHeaderModule} from '@vdw/angular-component-library';
import {TextileDataSharedModule} from '../../textile-data/textile-data-shared.module';
import {machineTypeRouting} from './machine-type.routing';
import {MachineTypeOverviewPageComponent} from './overview/machine-type-overview-page.component';

@NgModule({
  declarations: [MachineTypeOverviewPageComponent],
  imports: [machineTypeRouting, TextileDataSharedModule, EditorHeaderModule, CrudOverviewDataModule]
})
export class MachineTypeModule {}
